import { useConfigStore, useIsRecording } from '@cometchat/calls-sdk-core';
import clsx from 'clsx';
import React from 'react';
import './recording-indicator.css';

interface RecordingIndicatorProps {
  className?: string;
}

const RecordingIndicator: React.FC<RecordingIndicatorProps> = ({
  className = '',
}) => {
  const isRecording = useIsRecording();
  const hideRecordingStatusIndicator = useConfigStore(
    state => state.hideRecordingStatusIndicator,
  );
  if (!isRecording || hideRecordingStatusIndicator) {
    return null;
  }

  return (
    <div className="cometchat-calls-recording-indicator-position">
      <div className={clsx('cometchat-calls-recording-indicator', className)}>
        <div className="cometchat-calls-recording-indicator-dot" />
        <span className="cometchat-calls-recording-indicator-text">REC</span>
      </div>
    </div>
  );
};

export default RecordingIndicator;
